import React, { Component } from 'react';
import {
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { connect } from 'react-redux';
import { userActions } from '../../../core/users';
import iconlogout from '../../../assets/img/icon-menu-logout.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';


class UserMenu extends Component {

  logoutUser = () => {
    const { logout } = this.props;
    logout();
  }

  render() {
    const { user, profile } = this.props;

    return (
      <Nav className='w-100 mb-3' navbar>
        <UncontrolledDropdown nav inNavbar>
          <DropdownToggle nav caret className="user-profile border p-1 rounded d-flex">
            <span className="avatar mr-2">
              <img src={user.avatar} className="rounded-circle sm-avatar" alt="Avatar"/>
            </span>
            <span className="username d-inline-block font-weight-bold lh-sm flex-fill">
              {profile.data.first_name ? profile.data.first_name : user && user.first_name}<br/>
              <small className='text-muted'>My Profile</small>
            </span>
            <div className='my-auto mr-2 text-muted'>
              <FontAwesomeIcon icon={faChevronRight} />
            </div>
          </DropdownToggle>
          <DropdownMenu className="user-menu-items" right>
            <DropdownItem tag="a" href="/front/profile" className='py-2 '>
            <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 16 16" fill='currentColor' className='mt-n1 mr-1'>
            <path d="M10.8,7.5c0,0.5-0.2,1.1-0.5,1.5C10,9.5,9.6,9.8,9.1,10c-0.5,0.2-1.1,0.3-1.6,0.2c-0.5-0.1-1-0.4-1.4-0.8
              C5.7,9.1,5.4,8.6,5.3,8C5.2,7.5,5.3,7,5.5,6.4c0.2-0.5,0.6-0.9,1-1.2c0.5-0.3,1-0.5,1.5-0.5c0.7,0,1.4,0.3,1.9,0.8
              C10.5,6.1,10.7,6.8,10.8,7.5z M14.5,8c0,1.3-0.4,2.5-1.1,3.6c-0.7,1.1-1.7,1.9-2.9,2.4c-1.2,0.5-2.5,0.6-3.8,0.4
              c-1.3-0.3-2.4-0.9-3.3-1.8s-1.5-2.1-1.8-3.3C1.4,8,1.5,6.7,2,5.5s1.3-2.2,2.4-2.9S6.7,1.5,8,1.5c1.7,0,3.4,0.7,4.6,1.9
              C13.8,4.6,14.5,6.3,14.5,8z M13.5,8c0-0.7-0.2-1.5-0.4-2.2c-0.3-0.7-0.7-1.3-1.2-1.8c-0.5-0.5-1.2-0.9-1.9-1.2
              C9.3,2.6,8.5,2.5,7.8,2.5C4.8,2.6,2.5,5.1,2.5,8c0,1.3,0.5,2.6,1.4,3.6c0.4-0.5,0.8-1,1.4-1.3c0,0,0.1,0,0.2,0c0.1,0,0.1,0,0.1,0.1
              c0.7,0.6,1.5,0.9,2.4,0.9c0.9,0,1.8-0.3,2.4-0.9c0,0,0.1-0.1,0.1-0.1c0.1,0,0.1,0,0.2,0c0.5,0.4,1,0.8,1.4,1.3
              C13,10.6,13.5,9.3,13.5,8z"/>
            </svg>

              My Profile
            </DropdownItem>
            {user.documents && user.documents.length > 0 &&
            <DropdownItem tag="a" href="/front/my-documents" className='py-2 '>
              My Documents
            </DropdownItem>
            }
            <DropdownItem onClick={() => this.logoutUser()} className="py-2 text-danger">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={14} height={14} viewBox="0 0 14 14" fill='currentColor' className='mt-n1 mr-1'>
              <path d="M6.8,11.8c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H2.6c-0.2,0-0.3-0.1-0.5-0.2C2,12.2,2,12,2,11.8V2.2
                  C2,2,2,1.8,2.2,1.7s0.3-0.2,0.5-0.2h3.5c0.2,0,0.3,0.1,0.5,0.2C6.7,1.8,6.8,2,6.8,2.2S6.7,2.5,6.6,2.7C6.5,2.8,6.3,2.8,6.1,2.8H3.3
                  v8.3h2.8c0.2,0,0.3,0.1,0.5,0.2C6.7,11.5,6.8,11.6,6.8,11.8z M12.7,6.5l-2.2-2.2c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.3,0.1-0.5,0.2
                  C9.5,4.5,9.4,4.6,9.4,4.8c0,0.2,0.1,0.3,0.2,0.5l1.1,1.1H6.1C6,6.3,5.8,6.4,5.7,6.5C5.5,6.7,5.5,6.8,5.5,7s0.1,0.3,0.2,0.5
                  C5.8,7.6,6,7.7,6.1,7.7h4.5L9.6,8.7C9.5,8.8,9.4,9,9.4,9.2c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2c0.2,0,0.3-0.1,0.5-0.2
                  l2.2-2.2c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3C12.8,6.7,12.8,6.6,12.7,6.5z"/>
              </svg>
              Log out
              </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </Nav>
    );
  }
}
//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  const { profile, systemCheck } = state;
  return {
    profile,
    systemCheck
  }
}

const mapDispatchToProps = {
  logout: userActions.logout
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserMenu);
